import { render, staticRenderFns } from "./CommentAvatar.vue?vue&type=template&id=288f0836&"
import script from "./CommentAvatar.vue?vue&type=script&lang=ts&"
export * from "./CommentAvatar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports